import { Badge } from '@hyphen/hyphen-components';

/**
 * Pieces shared by the evidence pages and the control detail page.
 */

const STATUS_COLOR = { ok: 'green', partial: 'yellow', failed: 'red', skipped: 'grey' };

// What each status means to someone reading the list, not how it was computed.
const STATUS_LABEL = {
  ok: 'collected',
  partial: 'partial',
  failed: 'failed',
  skipped: 'skipped',
};

export function RunStatus({ status }) {
  return (
    <Badge variant="soft" color={STATUS_COLOR[status] ?? 'grey'}>
      {STATUS_LABEL[status] ?? status}
    </Badge>
  );
}

/**
 * A timestamp that stays on one line. In a table column a date and its time
 * wrap apart at the width that fits the rest of the row, and a column of
 * two-line dates reads as two columns.
 */
export function When({ iso }) {
  return <span style={{ whiteSpace: 'nowrap' }}>{formatWhen(iso)}</span>;
}

/** A timestamp in the reader's own zone, precise to the minute. */
export function formatWhen(iso) {
  if (!iso) return '—';
  return new Date(iso).toLocaleString(undefined, {
    year: 'numeric', month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit',
  });
}

/**
 * The first twelve characters of a hash, with the full value on hover — enough
 * to tell two captures apart at a glance without a column of noise.
 */
export function ShortHash({ value }) {
  if (!value) return <span>—</span>;
  return <code title={value}>{value.slice(0, 12)}</code>;
}

// Plain-language versions of the absent reasons, which are otherwise
// identifiers only a developer would parse.
export const ABSENT_LABEL = {
  inherited_default: 'provider default',
  not_applicable: 'not applicable',
  error: 'could not collect',
};
